module.exports = __webpack_public_path__ + "static/media/hopeless.7f4e49c6.jpeg";